import { CSSProperties, FC } from 'react';
import clsx from 'clsx';
import { Box } from '../Box';

import styles from './index.module.css';

interface StatusIconProps {
  className?: string;
  status?: string;
  style?: CSSProperties;
}

export const StatusIcon: FC<StatusIconProps> = ({
  className = '',
  status = '',
  style
}) => (
  <Box
    className={clsx(styles.icon, className, styles[`statusColor_${status}`])}
    style={style}
  />
);
